import { useEffect, useState } from "react";

/**
 * Get the current scroll position of the window.
 *
 * @returns {{x: number, y: number}} - The current scroll position of the window.
 */
export function useWindowScroll(): { x: number; y: number } {

    const [state, setState] = useState({
        x: 0,
        y: 0,
    });


    const interval = setInterval(() => {

    }, 100)

    useEffect(() => {

        if (typeof window !== 'object') {
            return
        }
        const handler = () => {
            setState({
                x: window?.scrollX,
                y: window?.scrollY,
            });
        };

        document?.addEventListener("scroll", handler, {
            capture: false,
            passive: true,
        });

        return () => {
            document?.removeEventListener("scroll", handler);
        };
    }, []);

    return state;
}